
const digest = 'b18701f4fad668002972c768e74dc5cab1151a07aff168f2f218f6ad287066cc';
const classes = {"wrapper":"_wrapper_1gv0u_1","background":"_background_1gv0u_7","list":"_list_1gv0u_11","grid":"_grid_1gv0u_22"};
const css = `._wrapper_1gv0u_1 {
  font-family: Rubik, "sans-serif";
  height: 100%;
  display: flex;
  flex-direction: column;
}
._wrapper_1gv0u_1 ._background_1gv0u_7 {
  background: #fbfbfd;
}

._list_1gv0u_11 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  font-family: "Rubik", sans-serif;
  background: #fbfbfd;
  padding-top: 12px;
  gap: 12px;
}

._grid_1gv0u_22 {
  margin: 0 auto;
  display: grid;
  gap: 24px;
  background: #fbfbfd;
  padding-top: 12px;
}

@media (min-width: 600px) {
  ._grid_1gv0u_22 {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 900px) {
  ._grid_1gv0u_22 {
    grid-template-columns: repeat(6, 1fr);
  }
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  